import get from 'lodash/get';
import { storage } from '@/utils';

export default {
	fetchGuides({ dispatch }) {
		return dispatch('fetch', {
			type: 'guides',
			imgSize: 'medium_large',
		});
	},
	fetchCourses({ dispatch }) {
		return dispatch('fetch', {
			type: 'courses',
		});
	},
	fetch({ commit, dispatch }, { type, imgSize = 'medium' }) {
		return new Promise((resolve, reject) => {
			commit('fetching', type, { root: true });

			const update = ({ items, total }) => {
				commit('fetched', type, { root: true });
				commit('doneLoading', type, { root: true });
				commit(`${type}Set`, items);
				commit(`${type}SetTotal`, total);
				resolve();
			};

			const found = storage.session.getItem(`omu-${type}`);
			if (get(found, 'items')) {
				return update(found);
			}

			return this._vm.$api
				.get({ wpEndpoint: `omapp/v1/omu/${type}` })
				.then(({ body, headers }) => {
					const found = {
						items: body.map((item) => ({
							id: item.id,
							title: get(item, 'title.rendered'),
							link: item.link,
							img: get(item, `_embedded.wp:featuredmedia.0.media_details.sizes.${imgSize}`),
						})),
						total: headers['x-wp-total'],
					};
					storage.session.setItem(`omu-${type}`, found);
					update(found);
				})
				.catch(({ ...error }) => {
					commit('doneFetching', type, { root: true });
					dispatch('handleError', {
						explanation: `Something went wrong while fetching ${type}.`,
						error,
						reject,
					});
				});
		});
	},
	handleError({ commit }, { explanation, error, reject }) {
		if (explanation) {
			error.explanation = explanation;
		}

		error.closes = true;
		commit('maybeAddError', error, { root: true });
		// eslint-disable-next-line no-console
		console.error({ error });
		reject(error);
	},
};
